import React from "react";
import ReactDOM from "react-dom";
import App from "views/App";
import * as serviceWorker from "./serviceWorker";
import { IntlProvider, addLocaleData } from "react-intl";
import en from "react-intl/locale-data/en";
import es from "react-intl/locale-data/es";
import ja from "react-intl/locale-data/ja";
import zh from "react-intl/locale-data/zh";
import ko from "react-intl/locale-data/ko";
import it from "react-intl/locale-data/it";
import fr from "react-intl/locale-data/fr";
import de from "react-intl/locale-data/de";
import Cookies from "universal-cookie";
import '@babel/polyfill';

import "scss/base/corrections.scss";

import "scss/theme/layout.scss";
import "scss/theme/fonts.scss";
import {Provider} from "./store/Context";
import { SideMenuProvider } from "./sideMenu/sideMenu.context";

addLocaleData([...en, ...es, ...ja, ...zh, ...ko, ...it, ...fr, ...de]);
const cookies = new Cookies();
  let languageCookie = cookies.get("dispatchSite");
if (languageCookie) {
  var language = languageCookie.split("-")[1];
  if (language.indexOf("en") !== -1) language = "en";
  if (language.indexOf("zh") !== -1) language = "zh";
  if (language.indexOf("ko") !== -1) language = "ko";
}

const possibleLanguage = language ? language : 'en';

const messages = require(`assets/json/messages/messages-${possibleLanguage}.json`);
ReactDOM.render(
  <IntlProvider locale={possibleLanguage} messages={messages}>
    <Provider>
      <SideMenuProvider>
        <App />
      </SideMenuProvider>
    </Provider>
  </IntlProvider>,
  document.getElementById("dicesTool")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
